import type { TFunction } from 'i18next';

export interface SmartCopyTemplateActionState {
  disabled: boolean;
  disabledReason?: string;
}

/**
 * Disabled state + tooltip for a Smart Copy "from template" action: enabled
 * only when exactly one row is selected; zero or many disable it with an
 * entity-parameterised reason.
 *
 * Pass the lowercase entity noun (e.g. 'test result') — it interpolates into
 * the `{{entity}}` i18n strings and must match the deployed wording.
 */
export const getSmartCopyTemplateActionState = (
  t: TFunction<'common'>,
  { entityNoun, selectedCount }: { entityNoun: string; selectedCount: number }
): SmartCopyTemplateActionState => {
  if (selectedCount === 1) {
    return { disabled: false };
  }

  return {
    disabled: true,
    disabledReason:
      selectedCount === 0
        ? t('smartCopy.templateDisabledNoneSelected', { entity: entityNoun })
        : t('smartCopy.templateDisabledMultiSelected', { entity: entityNoun }),
  };
};
